import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-uri-teal to-uri-teal-dark text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/f384832b5a766ad07a1721f0b33de73e/6ee0193abd8804ba3f9736fe623d9173.png" 
                alt="URI Logo" 
                className="h-14 w-auto bg-white rounded-lg p-1"
              />
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Cuidado profesional de salud para sus seres queridos. Disponible 24/7 para todas sus necesidades de salud.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-base mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Cuidado Residencial
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Asistencia Hospitalaria
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('booking')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Reservar Cita
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('intake')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Admisión de Pacientes
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-base mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-base mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+584143363083" className="text-sm text-white/80 hover:text-white transition-colors">
                  +58 414 336 3083
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line"></i>
                <a href="https://wa.me/584143363083" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:info@uri-care.com" className="text-sm text-white/80 hover:text-white transition-colors break-all">
                  info@uri-care.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span className="text-sm text-white/80">Disponible 24/7</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/80">
            © 2025 URI Care. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-white/80 hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
